import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {PrimeNgModule} from '@app/shared/modules/prime-ng/prime-ng.module';
import {EffectsModule} from '@ngrx/effects';
import {SharedModule} from '../shared/shared.module';
import {CategoryListComponent} from './components/category-list/category-list.component';
import {CategoryListEffects} from './state/category-list.effects';

@NgModule({
  imports: [
    RouterModule,
    FormsModule,
    SharedModule,
    PrimeNgModule,
    EffectsModule.forFeature([CategoryListEffects]),
    CategoryListComponent,
  ],
})
export class CategoryModule {}
